"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getPickupPointValueByDisplayOrder = void 0;
const getPickupPointValueByDisplayOrder = (displayType, instantResultPickupPoint)=>{
    const propertyName = displayType.charAt(0).toLowerCase() + displayType.slice(1);
    const result = instantResultPickupPoint[propertyName];
    return typeof result === 'undefined' ? '' : String(result);
};
exports.getPickupPointValueByDisplayOrder = getPickupPointValueByDisplayOrder;
